import HttpMethod from "./HttpMethod";
import { BASE_BACKEND_URL } from "../api/config";
import { store } from '../redux/store'; 
class HttpApis {
  constructor() {
    this.baseUrl = BASE_BACKEND_URL;
  }
  // Helper method to get auth token from persisted Redux store
 getAuthToken() {
  try {
    const authData = JSON.parse(localStorage.getItem("authData"));
    return authData?.token || null;
  } catch {
    return null;
  }
}

  // Helper to merge headers with auth token if available
  getHeaders(customHeaders = {}) {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...customHeaders
    };
    const authToken = this.getAuthToken();
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
    return headers;
  }
  // Generic request methods with automatic header handling and error catching
  async get(endpoint, params = '', customHeaders = {}) {
    try {
      const response = await HttpMethod._get(
        `${this.baseUrl}${endpoint}`,
        params,
        this.getHeaders(customHeaders)
      );
      return response;
    } catch (error) {
      console.error(`GET request failed for ${endpoint}:`, error);
      throw error;
    }
  }
  async post(endpoint, params = {}, customHeaders = {}) {
    try {
      const response = await HttpMethod._post(
        `${this.baseUrl}${endpoint}`,
        params,
        this.getHeaders(customHeaders)
      );
      return response;
    } catch (error) {
      console.error(`POST request failed for ${endpoint}:`, error);
      throw error;
    }
  }
  async delete(endpoint, params = {}, customHeaders = {}) {
    try {
      const response = await HttpMethod._delete(
        `${this.baseUrl}${endpoint}`,
        params,
        this.getHeaders(customHeaders)
      );
      return response;
    } catch (error) {
      console.error(`DELETE request failed for ${endpoint}:`, error);
      throw error;
    }
  }

  // Content Related APIs
  async getMenuList(params) {
    return this.get('client/v1/home', params);
  }
  async getSection(slug) {
    return this.get(`client/v1/content/${slug}`);
  }
  async getSeriesList(limit = 1000) {
    return this.get(`client/v1/series?limit=${limit}`);
  }
 async getMoviesList(limit = 1000) {
  return this.get(`client/v1/movies?limit=${limit}`);
}

  async getCreatorList(limit = 1000) {
    return this.get(`client/v1/creators/list?limit=${limit}`);
  }
  async getCreatorListbycontentId(id, limit = 1000) {
    return this.get(`client/v1/creators/${id}/content?limit=${limit}`);
  }
  async getCreatorListbyId(id) {
    return this.get(`client/v1/creators/${id}`);
  }
  async getList(limit = 1000) {
    return this.get(`client/v1/my-list?limit=${limit}`);
  }
  async addToList(slug) {
    return this.post(`client/v1/my-list/${slug}`);
  }
  async deleteToList(slug) {
    return this.delete(`client/v1/my-list/${slug}`);
  }


  async getSearchResults(query) {
    return this.get(`client/v1/search?query=${encodeURIComponent(query)}`);
  }

  async getRecentSearchResults() {
    return this.get(`client/v1/recent-search`);
  }

  async postRecentSearchResults(content_type, content_id) {
    const formData = new FormData();
    formData.append("content_type", content_type);
    formData.append("content_id", content_id);
    return this.post(
      "client/v1/recent-search",
      formData
    );
  }


  async getChanelsWithScheduls() {
    return this.get('active-channels-with-schedules');
  }
  async getConfig() {
    return this.get('v1/config');
  }
  async getGenrebyId(genre_id,limit = 1000) {
    return this.get(`client/v1/genres/${genre_id}?limit=${limit}`);
  }
  // Authentication Related APIs
  async Login(params) {
    return this.post('client/v1/subscribers/login', params);
  }
  async signUp(params) {
    return this.post('client/v1/subscribers/register', params);
  }
  async signOut(params) {
    return this.post('client/v1/subscribers/logout', params);
  }
  async refreshToken(refreshToken) {
    return this.post('client/v1/refresh-token', {
      refresh_token: refreshToken,
    });
  }
  async accessCode(params, config = {}) {
    return this.post('client/v1/activation-code/confirm', params, config);
  }

    async Analytics(params, config = {}) {
    return this.post('client/v1/app-event', params, config);
  }

  // User Preferences APIs
  // HttpApis.js
  async postAddTofavourite(slug, customHeaders = {}) {
    return this.post(
      `client/v1/like-dislike/${slug}`,
      { action: "like" },
      customHeaders
    );
  }

  async postRemovefavourite(slug, customHeaders = {}) {
    return this.post(
      `client/v1/like-dislike/${slug}`,
      { action: "dislike" },
      customHeaders
    );
  }

  async getWatchList() {
    return this.get('client/v1/liked');
  }
  // Watching History APIs
  async postContinueWatching(params) {
    return this.post('client/v1/continue-watching', params);
  }
async getContinueWatchingList({ limit = 1000, headers = {} } = {}) {
  return this.get(`client/v1/continue-watching?limit=${limit}`, { headers });
}

async getAllProfile() {
  return this.get(`client/v1/subscribers/profiles`);
}

async getAllAvatarImg() {
  return this.get(`client/v1/avatars`);
}

 async postSetProfile(profile_id) {
    return this.post(`client/v1/subscribers/profiles/set/${profile_id}`);
  }

   async postUpdateProfile(profile_id,body) {
    return this.post(`client/v1/subscribers/profiles/${profile_id}`, body);
  }

    async deleteProfile(profile_id) {
    return this.delete(`client/v1/subscribers/profiles/${profile_id}`);
  }
  async getSingleProfile(profile_id) {
  return this.get(`client/v1/subscribers/profiles/${profile_id}`);
}

async postCreateProfile(body) {
  return this.post(`client/v1/subscribers/profiles/create`, body);
}


  // Subscription & Payment APIs
  async purchase(params) {
    return this.post('client/v1/purchase', params);
  }
 
  // tv-activation-api //
  async tvActivation(body, headers) {
    return await HttpMethod._post(
      `${BASE_BACKEND_URL}tv/link-activation-code`,
      body,
      headers
    );
  }
}


// Create a singleton instance
const httpApis = new HttpApis();
Object.freeze(httpApis);
export default httpApis;